"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapStyled = exports.ScrollWrap = exports.CarouselWrap = exports.ButtonStyled = exports.Line2 = exports.HeadlineH5 = exports.HeadlineH4 = exports.Headline3 = exports.Headline2 = exports.Headline1 = exports.GridBox = exports.Row = exports.ImageWrapper = exports.Item = exports.Container = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _headerTitles = require("../header-titles/header-titles.styled");

var _carousel = require("../carousel/carousel.styled");

var _styled = require("../../styled");

var _helpers = require("./helpers");

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    width: 100%;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  .slick-list {\n    padding: 0 29px;\n  }\n  ", " {\n    .slick-list {\n      padding: 0 39px;\n    }\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    ", " {\n      padding: 0 70px;\n    }\n    .slick-control.prev {\n      left: -55px;\n    }\n    .slick-control.next {\n      right: -55px;\n    }\n  }\n  ", " {\n    ", " {\n      margin: 0 auto !important;\n    }\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 5px;\n\n  ", " {\n    width: 100%;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 15px;\n  margin-bottom: 30px;\n  p {\n    margin: 0;\n  }\n  a {\n    color: inherit;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  font-size: 18px;\n  line-height: 27px;\n  margin-top: 30px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 30px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin: 30px auto 0;\n  max-width: 900px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  ", "\n\n  ", " {\n    .slick-slider {\n      .slick-control {\n        ", "\n      }\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: auto;\n  position: relative;\n  justify-content: center;\n\n  ", " {\n    margin-bottom: 30px;\n  }\n\n  ", " {\n    ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 30px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-left: 15px;\n  margin-right: 15px !important;\n  text-align: ", ";\n\n  ", " {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      padding-top: 0 !important;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      padding-bottom: 0 !important;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 60px;\n  padding-bottom: ", ";\n  position: relative;\n  text-align: center;\n\n  &:before {\n    height: 400px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n  }\n\n  ", " {\n    padding-bottom: 30px;\n    padding-top: 30px;\n  }\n\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = (0, _uiKit.styled)("div")(_templateObject(), function (_ref) {
  var $hasButtons = _ref.theme.$hasButtons;
  return $hasButtons ? '60px' : '30px';
}, _uiKit.GridBreakpointsMediaDown.sm, _uiKit.Colors.gray800, function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.$theme && (0, _helpers.getTheme)(theme.$theme);
}, function (_ref3) {
  var removeBottomPadding = _ref3.removeBottomPadding;
  return removeBottomPadding && (0, _uiKit.css)(_templateObject2());
}, function (_ref4) {
  var removeTopPadding = _ref4.removeTopPadding;
  return removeTopPadding && (0, _uiKit.css)(_templateObject3());
});
exports.Container = Container;
var Item = (0, _uiKit.styled)(_uiKit.Box)(_templateObject4(), function (_ref5) {
  var $textAlign = _ref5.theme.$textAlign;
  return $textAlign;
}, _uiKit.GridBreakpointsMediaDown.md);
exports.Item = Item;
var ImageWrapper = (0, _uiKit.styled)("div")(_templateObject5());
exports.ImageWrapper = ImageWrapper;
var Row = (0, _uiKit.styled)("div")(_templateObject6(), Item, _uiKit.GridBreakpointsMediaDown.lg, function (_ref6) {
  var hideMd = _ref6.hideMd;
  return hideMd && "display: none";
});
exports.Row = Row;
var GridBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject7(), function (_ref7) {
  var _ref7$theme = _ref7.theme,
      $styles = _ref7$theme.$styles,
      $aspectRatio = _ref7$theme.$aspectRatio,
      $columns = _ref7$theme.$columns,
      $mobileLayout = _ref7$theme.$mobileLayout,
      $gridType = _ref7$theme.$gridType;
  return (0, _helpers.getImageRowStyles)({
    styles: $styles,
    columns: $columns,
    aspectRatio: $aspectRatio,
    mobileLayout: $mobileLayout,
    offset: 30,
    container: Row,
    child: Item,
    image: ImageWrapper,
    gridType: $gridType
  });
}, _uiKit.GridBreakpointsMediaDown.sm, _carousel.CarouselDefaultArrowStyles);
exports.GridBox = GridBox;
var Headline1 = (0, _uiKit.styled)("h3")(_templateObject8(), _styled.Line1Styles);
exports.Headline1 = Headline1;
var Headline2 = (0, _uiKit.styled)("h2")(_templateObject9(), _styled.Line2Styles);
exports.Headline2 = Headline2;
var Headline3 = (0, _uiKit.styled)("p")(_templateObject10(), _styled.Line3Styles);
exports.Headline3 = Headline3;
var HeadlineH4 = (0, _uiKit.styled)("h4")(_templateObject11(), _styled.HeadlineStyles1);
exports.HeadlineH4 = HeadlineH4;
var HeadlineH5 = (0, _uiKit.styled)("h5")(_templateObject12(), _styled.HeadlineStyles3);
exports.HeadlineH5 = HeadlineH5;
var Line2 = (0, _uiKit.styled)("div")(_templateObject13(), _styled.HeadlineStyles2);
exports.Line2 = Line2;
var ButtonStyled = (0, _uiKit.styled)("div")(_templateObject14(), _uiKit.GridBreakpointsMediaDown.sm);
exports.ButtonStyled = ButtonStyled;
var CarouselWrap = (0, _uiKit.styled)("div")(_templateObject15(), _uiKit.GridBreakpointsMediaUp.sm, _carousel.CarouselContainer, _uiKit.GridBreakpointsMediaDown.md, Item);
exports.CarouselWrap = CarouselWrap;
var ScrollWrap = (0, _uiKit.styled)("div")(_templateObject16(), _uiKit.GridBreakpointsMediaDown.sm);
exports.ScrollWrap = ScrollWrap;
var HeaderWrapStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject17(), _headerTitles.DescriptionStyled);
exports.HeaderWrapStyled = HeaderWrapStyled;